<template>
  <div>
   
    <br />
     <Menu></Menu>
     <div class="grid-responsive">
          <h1 class="title">Servicos</h1>
 
          <Servico ref="Servico" v-on:servicos="servicos"  />
          <br />      <br />          
          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Nome</th>                    
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in items" :key="item.id">
                  <td>{{item.idServico}}</td>                  
                  <td>{{item.nomeServico}}</td>                   
                  <td class="text-right td-responsive">
                     
                    <button
                      type="button"
                      class="btn btn-outline-primary"
                      style="margin-right: 20px;"
                      @click="visualizarServico(item.idServico)"
                    >
                      <i class="fas fa-edit"></i>
                    </button>
                    <button type="button" class="btn btn-outline-danger" @click="deletarServico(item.idServico)">
                      <i class="fas fa-trash"></i>
                    </button>
                  </td>  
                </tr>
              </tbody>
            </table>
          </div>
        </div>
    </div>
   
</template>

<style scoped>
tfoot {
  background-color: #fff;
}
#buttonActions {
  margin-top: 30px;
}
</style>

<script>
 

import Menu from "@/components/MenuAdmin.vue";
import Servico from './Servico'

import {AdminService} from "@/http"


export default {
  name: "servicosAdmin",
  components: {
    Menu,  
    Servico
  },
  data: () => {
    return {
      items:[],  
      showModal: false,  
    };
  },
  methods: {
    
    visualizarServico(idServico) {
          
        this.$refs["Servico"].visualizarServico(idServico)

    },
    deletarServico(idServico){

       if(!confirm("Deseja deletar?")){
          return false
       }


       AdminService.DeletarServico(idServico).then(response=>{
         
        window.console.warn(response.statusText)
        this.$notify({ group:"notify", text: "Deletado com sucessso",  type:"success", });
        this.servicos()
         

      }).catch(error=>{
          window.console.log(error)
      })

    },
    servicos(){

      AdminService.Servicos().then(response=>{
       this.items = response.data

      }).catch(error=>{
          window.console.log(error)
      })

    },  
     
  },
  created() {
    this.servicos()
   
  }, 
  watch:{
    //searchServicos: _.debounce(function(text) { this.handlerServicos(text) }, 500),  
  }
};
</script>
 
